import { Paper, useTheme, CardMedia, Box, Typography } from '@mui/material';

interface ProductCardProps {
    item: number;
}

const Card: React.FC<ProductCardProps> = ({ item }) => {
    const theme = useTheme();

    return (
        <Paper
            elevation={3}
            sx={{
                display: 'flex',
                backgroundImage: 'linear-gradient(180deg, rgba(120, 4, 4, 0.4), rgba(11, 11, 11, 0.1))',
                backdropFilter: 'blur(8px)',
                border: '1px solid',
                borderColor: "#3f3f46",
                borderRadius: theme.shape.borderRadius,
                boxShadow: '0px 1px 7px rgba(255, 0, 0, 0.4)',
                overflow: 'hidden',
                cursor: 'pointer',
                position: 'relative',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                    transform: { xs: 'none', sm: 'scale(1.05)' },
                    '& .image': {
                        opacity: 0.3, // Reduce image opacity
                        filter: 'blur(2px)', // Apply slight blur
                    },
                    '& .text': {
                        opacity: 1, // Make text fully visible
                    },
                },
                width: '100%',
                height: '0',
                paddingBottom: '140%',
            }}
        >
            <CardMedia
                component="img"
                className="image"
                sx={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    objectFit: 'cover',
                    transition: 'opacity 0.3s ease-in-out, filter 0.3s ease-in-out',
                    opacity: 1,
                    filter: 'blur(0)', // Default state without blur
                }}
                image="/card2.jpg"
                alt="Card Image"
            />
            <Box
                className="text"
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pointerEvents: 'none', // Ensure text is not clickable
                    opacity: 0, // Initially hidden
                    transition: 'opacity 0.3s ease-in-out',
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        color: 'white',
                        textAlign: 'center',
                    }}
                >
                    Card Details
                </Typography>
            </Box>
        </Paper>
    );
};

export default Card;